import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['percentageCircle', 'percentageText']

  connect() {
    let { value, total, dimension} = this.element.dataset
    value = parseInt(value)
    total = parseInt(total)

    if (!value || !total || total === 0) {
      this.percentageTextTarget.textContent = 'N/A'
    } else {
      const maxPercentage =  Math.round(value * 100 / total)
      const step = value / maxPercentage
      let percentage = 0

      const intervalId = setInterval(() => {
        if (percentage > maxPercentage) {
          this.percentageTextTarget.textContent = `${value}${dimension}`;
          clearInterval(intervalId)
          return
        }

        this.percentageTextTarget.textContent = `${Math.round(percentage * step)}${dimension}`;
        this.percentageCircleTarget.style.strokeDashoffset = 100 - percentage;

        percentage += 1
      }, 20)
    }
  }
}
